import './FormPage.scss';
import FormSection from '../../components/ FormSection/FormSection';

const FormPage = () => {
    return (
        <main className="form-page">
            <FormSection/>   
        </main>
    )
}

export default FormPage
